"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageDomain = exports.arrayDifference = exports.isUnverified = exports.isUserGuest = exports.getUserId = exports.getUserEmail = exports.getCurrentLanguage = exports.getCurrentLanguageCode = exports.getCurrentCurrency = void 0;
var getCurrentCurrency = function (state) {
    return state.layout.currencies.currentCurrencyId;
};
exports.getCurrentCurrency = getCurrentCurrency;
var getCurrentLanguageCode = function (state) {
    return state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1;
};
exports.getCurrentLanguageCode = getCurrentLanguageCode;
var getCurrentLanguage = function (state) {
    return state.layout.language.current;
};
exports.getCurrentLanguage = getCurrentLanguage;
var getUserEmail = function (state) { return state.user.email; };
exports.getUserEmail = getUserEmail;
var getUserId = function (state) { return state.user.id; };
exports.getUserId = getUserId;
var isUserGuest = function (state) { return state.user && state.user.id ? false : true; };
exports.isUserGuest = isUserGuest;
var isUnverified = function (state) { return state.user && !state.user.isConfirmed ? true : false; };
exports.isUnverified = isUnverified;
var arrayDifference = function (a, b) { return a.filter(function (it) { return b.indexOf(it) === -1; }); };
exports.arrayDifference = arrayDifference;
var getImageDomain = function (state) {
    return state.layout.imgDomain;
};
exports.getImageDomain = getImageDomain;
